import React from "react";
import Image from "@components/Image";
import Link from "@components/Link";
import Button from "@components/Button";
import styles from "./Article.module.scss";
import cx from "classnames";
import _ from "lodash";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";

const View = ({
  type = "left",
  image = {},
  description = "",
  title = "",
  border = "",
  slug,
  className,
  articleClassName,
}: any) => {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  return (
    <Link className={className} href={router.toUrl("storiesArticle", { slug })}>
      <article className={cx(styles.section, styles[type], articleClassName)}>
        <div
          className={cx(styles.contentBox, {
            [styles.borderNone]: border === "none",
          })}
        >
          <div className={styles.box}>
            <div className={cx("ama-section-title capitalize", styles.title)}>
              {!!title && title}
            </div>
            <div className={cx("ama-content", styles.description)}>
              {!!description && description}
            </div>
            <div className={styles.discoverMore}>
              <Button
                type="icon"
                dark
                className={cx("uppercase button", styles.button)}
                label={i18n.t("Button.discoverMore")}
                suffix="shape-arrow"
                // onClick={() => router.push("storiesArticle", { slug })}
              />
            </div>
          </div>
        </div>
        <div className={styles.imgBox}>
          <Image
            wrapperProps={{ className: cx(styles.img) }}
            src={_.get(image, "src")}
            alt={_.get(image, "alt")}
            layout="fill"
            objectFit="cover"
            scale="1.2"
          />
        </div>
      </article>
    </Link>
  );
};
export default View;
